import type { FC, ReactNode } from 'react'

import { ArrowUp } from 'lucide-react'
import { Monogram } from '@/components/generals/monogram'
import { COMMISSION_HREF, NAV_ITEMS } from '@/constants/navigation'
import { siteConfig } from '@/constants/site'

const SiteFooter: FC = (): ReactNode => {
    return (
        <footer className='border-t border-white/5 bg-obsidian'>
            <div className='mx-auto max-w-7xl px-5 py-16 sm:px-8'>
                <div className='flex flex-col gap-12 md:flex-row md:items-start md:justify-between'>
                    <div className='max-w-sm'>
                        <div className='flex items-center gap-3'>
                            <Monogram className='size-9' />
                            <span className='font-heading text-sm font-bold tracking-[0.2em] text-white'>
                                ALIF LAMATO
                            </span>
                        </div>
                        <p className='mt-6 font-heading text-xs font-bold leading-relaxed tracking-[0.14em] text-gold'>
                            {siteConfig.tagline.toUpperCase()}
                        </p>
                        <p className='mt-4 text-sm leading-relaxed text-titanium-light'>
                            Ultra-luxury bespoke forged wheels and monoblock atelier, founded by master artisan Alif Lamato.
                        </p>
                    </div>

                    <nav aria-label='Footer'>
                        <ul className='grid grid-cols-2 gap-x-14 gap-y-4 sm:grid-cols-3'>
                            {NAV_ITEMS.map((item) => (
                                <li key={item.href}>
                                    <a href={item.href} className='font-mono text-[11px] uppercase tracking-[0.24em] text-titanium-light transition-colors hover:text-gold'>
                                        {item.label}
                                    </a>
                                </li>
                            ))}
                            <li>
                                <a href={COMMISSION_HREF} className='font-mono text-[11px] uppercase tracking-[0.24em] text-gold transition-colors hover:text-white'>
                                    Commission
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>

                <div className='mt-16 flex flex-col gap-6 border-t border-white/5 pt-8 sm:flex-row sm:items-center sm:justify-between'>
                    <p className='text-xs text-titanium'>
                        &copy; Alif Lamato Atelier. Every set handcrafted to order.
                    </p>
                    <a href='#film' className='inline-flex items-center gap-2 self-start font-mono text-[11px] uppercase tracking-[0.24em] text-titanium-light transition-colors hover:text-gold sm:self-auto'>
                        Back to the film
                        <ArrowUp className='size-3.5' aria-hidden='true' />
                    </a>
                </div>
            </div>
        </footer>
    )
}

export default SiteFooter
